import { css } from 'emotion'

export const flexRightStyles = css`
  display: flex;
  justify-content: flex-end;
`
